import React from 'react';
import { Controller } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

const RHFCheckbox = ({
  name,
  control,
  label,
  info,
  forceError,
  rules,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({
      field: { value, onChange, ...field },
      fieldState: { error, invalid, isTouched }
    }) => {
      const isError = ((isTouched || forceError) && invalid) || !!error;
      const helperText = (((isTouched || forceError) || !!error) && error?.message) || info;

      return (
        <FormControl error={isError} {...rest}>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!value}
                onChange={e => onChange(e.target.checked)}
                {...field}
                {...rest}
              />
            }
            label={label}
          />
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      );
    }}
  />
);

export default RHFCheckbox;
